import React, { useEffect, useState } from 'react';
import { getUserProfile 
  , updateUserProfile, logoutAllDevices, logout, changeUserPassword
} from '../../../slices/userSlice'; // Acción para obtener el perfil
import { useDispatch, useSelector } from 'react-redux';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';  // Icono de cámara de Heroicons
import { useNavigate } from "react-router-dom";


const secondaryNavigation = [
  { name: 'Cuenta', href: '#', current: true },
  { name: 'Notificaciones', href: '/admin/notifications', current: false },
  { name: 'Calendario', href: '/admin/calendly', current: false },
  { name: 'Equipos', href: '#', current: false },
  { name: 'Integraciones', href: '#', current: false },
]

export default function AdminSettings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo, loading, error } = useSelector((state) => state.user);
  const [password, setPassword] = useState('');
  const [loading1, setLoading1] = useState(false);
  const [error1, setError1] = useState(null);
  const [selectedImageProfile, setSelectedImageProfile] = useState(null);  // Estado para la imagen seleccionada
  const [imageUrl, setImageUrl] = useState(null);  // Estado para la URL de la imagen mostrada


  
  // Para los campos de texto
  const [formData, setFormData] = useState({
    firstName: userInfo?.name || "",
    lastName: userInfo?.lastName || "",
    username: userInfo?.username || "",
    email: userInfo?.email || ""
  });

  const [passwordFields, setPasswordFields] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });
  

  // Estado para rastrear si ha habido cambios en los campos
  const [hasChanges, setHasChanges] = useState(false);

  // useEffect para cargar el perfil del usuario
  useEffect(() => {
    if (!userInfo || !userInfo.email) {
      // Si los datos del usuario están incompletos, hacemos la llamada para obtener el perfil completo
      dispatch(getUserProfile());
    }
  }, [dispatch, userInfo]);

  // Usamos useEffect para actualizar la imagen cuando se selecciona una nueva
  useEffect(() => {
    if (selectedImageProfile) {
      setHasChanges(true); // Actualizamos el estado de si hay cambios o no
      const objectUrl = URL.createObjectURL(selectedImageProfile);
      setImageUrl(objectUrl);
      return () => {
        URL.revokeObjectURL(objectUrl); // Revoke the object URL to avoid memory leaks
      };
    }
  }, [selectedImageProfile]); // Este efecto se ejecutará cada vez que la imagen cambie

  const userProfileImage =
    userInfo?.profileImage ||
    `https://ui-avatars.com/api/?name=${formData.firstName}${formData.lastName}&background=random`;

  const handleProfilePicture = (file) => {
    if (file) {
      setSelectedImageProfile(file);  // Se actualiza el estado con el nuevo archivo
    } else {
      setImageUrl(null); // Reset if no file is selected (in case of cancel)
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handlePasswordChange2 = (e) => {
    const { name, value } = e.target;
    setPasswordFields(prev => ({
      ...prev,
      [name]: value
    }));
  };
  

  const handleLogoutAll = async (e) => {
    e.preventDefault();
    setLoading1(true);
    setError1(null);

    try {
      // Despachamos la acción para hacer el logout en todos los dispositivos
      await dispatch(logoutAllDevices(password));

      // Si todo fue bien, podemos resetear el password y mostrar un mensaje de éxito
      setPassword('');
      dispatch(logout());  // Aquí limpiamos el estado en Redux
      navigate('/');  // Redirigimos al usuario a la página principal

    } catch (error) {
      // Si hay un error, lo mostramos
      setError1(error || 'Error al cerrar sesión en otros dispositivos');
    } finally {
      setLoading1(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmNewPassword } = passwordFields;
  
    if (newPassword !== confirmNewPassword) {
      alert("Las contraseñas nuevas no coinciden.");
      return;
    }
  
    try {
      setLoading1(true);
      await dispatch(changeUserPassword({ currentPassword, newPassword }));
      alert('Contraseña cambiada con éxito');
      setPasswordFields({ currentPassword: '', newPassword: '', confirmNewPassword: '' }); // Limpiar los campos después del cambio
    } catch (error) {
      setError1(error.message || 'Error al cambiar la contraseña');
    } finally {
      setLoading1(false);
    }
  };
  

  const submitHandler = (e) => {
  const sendformData = new FormData();
  const data = { ...userInfo };
  
  // Aquí comparamos los campos para ver si han cambiado
  let hasChangesValid = false;
  const updatedUser = {};

  // Comparamos los valores antiguos y nuevos, solo agregamos los que cambiaron
  if (formData.firstName !== data.name) {
    updatedUser.name = formData.firstName;
    hasChangesValid = true;
  }
  if (formData.lastName !== data.lastName) {
    updatedUser.lastName = formData.lastName;
    hasChangesValid = true;
  }
  if (formData.username !== data.username) {
    updatedUser.username = formData.username;
    hasChangesValid = true;
  }
  if (formData.email !== data.email) {
    updatedUser.email = formData.email;
    hasChangesValid = true;
  }
  // Si hay cambios, agregamos a formData
  if (hasChangesValid) {
    sendformData.append("myUser", JSON.stringify(updatedUser));
  }

  // Agregar la imagen solo si ha cambiado
  if (selectedImageProfile) {
    sendformData.append("imageProfile", selectedImageProfile);
  }


  // Dispatch para actualizar el perfil
  if (hasChanges || selectedImageProfile) {
    dispatch(updateUserProfile(sendformData));
    dispatch(getUserProfile())
  }
   
  };

  // Manejo de cambio para los campos de texto
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };
      // Verificar si hay cambios
      const hasChanges = Object.keys(newFormData).some((key) => newFormData[key] !== userInfo[key]);
      setHasChanges(hasChanges); // Actualizamos el estado de si hay cambios o no
      return newFormData;
    });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="h-screen bg-background">
      <main className="sm:w-full w-[390px] p-4 bg-background">
        <h1 className="sr-only">Configuración de la cuenta</h1>

        <header className="border-b border-gray-200 mb-8">
          {/* Navegación secundaria */}
          <nav className="flex py-4">
            <ul
              
              className="flex sm:w-full w-[200px]  flex-none sm:gap-x-6 gap-x-3 sm:px-4 text-sm font-semibold text-text  lg:px-8"
            >
              {secondaryNavigation.map((item) => (
                <li className='text-xs sm:text-base' key={item.name}>
                  <button onClick={() => navigate(`${item.href}`) } className={item.current ? 'text-indigo-600' : ''}>
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </header>

        {/* Formularios de configuración */}
        <div className="divide-y divide-gray-200">
          <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
            <div>
              <h2 className="text-base font-semibold text-text">Información Personal</h2>
              <p className="mt-1 text-sm text-gray-500">Usa una dirección permanente donde puedas recibir correo.</p>
            </div>

            <form className="md:col-span-2" onSubmit={submitHandler}>
              <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
                <div className="col-span-full flex items-center justify-center gap-x-8">
                  {/* Imagen de perfil */}
                  <img
                    alt="avatar"
                    src={imageUrl || userProfileImage}
                    className="h-32 w-32 rounded-lg bg-gray-200 object-cover"
                  />
                  <label htmlFor="profile-picture" className="cursor-pointer relative">
                    {/* Icono de cámara */}
                    <ArrowUpTrayIcon className="h-7 w-7 absolute bottom-0 right-0 p-2 bg-white rounded-full shadow-lg" />
                    <input
                      id="profile-picture"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleProfilePicture(e.target.files[0])}
                      className="hidden text-text "
                    />
                  </label>
                </div>

                {/* Resto del formulario */}
                <div className="sm:col-span-3">
                  <label htmlFor="first-name" className="block text-sm font-medium text-text">
                    Nombre
                  </label>
                  <div className="mt-2">
                    <input
                      id="first-name"
                      name="firstName"
                      type="text"
                      value={formData.firstName}
                      onChange={handleChange}
                      autoComplete="given-name"
                      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="last-name" className="block text-sm font-medium text-text">
                    Apellido
                  </label>
                  <div className="mt-2">
                    <input
                      id="last-name"
                      name="lastName"
                      type="text"
                      value={formData.lastName}
                      onChange={handleChange}
                      autoComplete="family-name"
                      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

                {/* Otros campos de formulario */}
                <div className="col-span-full">
                  <label htmlFor="email" className="block text-sm font-medium text-text">
                    Dirección de correo
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      autoComplete="email"
                      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="col-span-full">
                  <label htmlFor="username" className="block text-sm font-medium text-text">
                    Nombre de usuario
                  </label>
                  <div className="mt-2">
                    <div className="flex items-center rounded-md bg-background pl-3 outline-none">
                      <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm">aitiu.com/</div>
                      <input
                        id="username"
                        name="username"
                        type="text"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder="janesmith"
                        className="block min-w-0 grow bg-transparent py-1.5 pl-1 pr-3 text-base text-text placeholder:text-gray-500 focus:outline-none sm:text-sm"
                      />
                    </div>
                  </div>
                </div>

                {/* Botón "Guardar cambios" */}
                <div className="mt-2 flex justify-center m-auto ">
                  <button
                    type="submit"
                    disabled={!hasChanges} // Deshabilitamos el botón si no hay cambios o no hay foto
                    className={`w-60 sm:ml-40  rounded-md ${!hasChanges ? 'bg-gray-400' : 'bg-indigo-500'} px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2  focus-visible:outline-offset-2 focus-visible:outline-indigo-500`}
                  >
                    Guardar cambios
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-10 sm:px-6 md:grid-cols-3 lg:px-8">
            <div>
              <h2 className="text-base font-semibold text-text">Cambiar contraseña</h2>
              <p className="mt-1 text-sm text-gray-500">Actualiza la contraseña asociada a tu cuenta.</p>
            </div>

            <form className="md:col-span-2" onSubmit={handleChangePassword}>
  <div className="col-span-full">
    <label htmlFor="current-password" className="block text-sm font-medium text-text">
      Contraseña actual
    </label>
    <input
      id="current-password"
      name="currentPassword"
      type="password"
      value={passwordFields.currentPassword}
      onChange={handlePasswordChange2}
      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
    />
  </div>

  <div className="col-span-full">
    <label htmlFor="new-password" className="block text-sm font-medium text-text">
      Nueva contraseña
    </label>
    <input
      id="new-password"
      name="newPassword"
      type="password"
      value={passwordFields.newPassword}
      onChange={handlePasswordChange2}
      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
    />
  </div>

  <div className="col-span-full">
    <label htmlFor="confirm-password" className="block text-sm font-medium text-text">
      Confirmar contraseña
    </label>
    <input
      id="confirm-password"
      name="confirmNewPassword"
      type="password"
      value={passwordFields.confirmNewPassword}
      onChange={handlePasswordChange2}
      className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
    />
  </div>

  <div className="mt-8 flex">
    <button
      type="submit"
      className="rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
    >
      Guardar cambios
    </button>
  </div>
</form>

          </div>

           
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
          <div>
            <h2 className="text-base font-semibold text-text">Cerrar sesión en otros dispositivos</h2>
            <p className="mt-1 text-sm text-gray-500">
              Introduce tu contraseña para confirmar que deseas cerrar sesión en todos tus dispositivos.
            </p>
          </div>

          <form className="md:col-span-2" onSubmit={handleLogoutAll}>
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
              <div className="col-span-full">
                <label htmlFor="logout-password" className="block text-sm font-medium text-text">
                  Tu contraseña
                </label>
                <div className="mt-2">
                  <input
                    id="logout-password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    autoComplete="current-password"
                    className="block w-full rounded-md bg-background px-3 py-1.5 text-base text-text outline-none placeholder:text-gray-500 focus:outline focus:outline-2 focus:outline-indigo-500 sm:text-sm"
                  />
                </div>
              </div>
            </div>

            {error && <div className="text-red-500 mt-2">{error}</div>}
            
            <div className="mt-8 flex">
              <button
                type="submit"
                disabled={loading}
                className="rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                {loading ? 'Cerrando sesión...' : 'Cerrar sesión en otros dispositivos'}
              </button>
            </div>
          </form>
        </div>
          {/* <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
            <div>
              <h2 className="text-base font-semibold text-gray-800">Eliminar cuenta</h2>
              <p className="mt-1 text-sm text-gray-500">
                ¿Ya no deseas usar nuestro servicio? Puedes eliminar tu cuenta aquí. Esta acción no se puede deshacer y toda la información asociada se eliminará permanentemente.
              </p>
            </div>

            <form className="flex items-start md:col-span-2">
              <button
                type="submit"
                className="rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400"
              >
                Sí, eliminar mi cuenta
              </button>
            </form>
          </div> */}

          
        
      </main>
    </div>
  );
}
